import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '资源导航',
    links: [
      { label: '项目概览', href: '/category/xiangmu-gailan' },
      { label: '使用教程', href: '/category/shiyong-jiaocheng' },
      { label: '开源资源', href: '/category/kaiyuan-ziyuan' },
      { label: '代码库', href: '/category/daima-ku' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/category/changjian-wenti' },
      { label: '工具推荐', href: '/category/gongju-tuijian' },
      { label: '关于我们', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { label: 'GitHub', href: 'https://github.com', external: true },
      { label: 'npm', href: 'https://npmjs.com', external: true },
      { label: 'Stack Overflow', href: 'https://stackoverflow.com', external: true },
      { label: 'MDN 文档', href: 'https://developer.mozilla.org', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-semibold text-background-50 hover:text-primary-300 transition-colors mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                17
              </span>
              <span>17c.com GitHub</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              专注于 GitHub 开源项目的资源聚合平台，提供全面的项目解析、使用教程和开发工具推荐。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="GitHub">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="Twitter">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors" aria-label="RSS">
                <i className="ri-rss-fill text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) =>
                  link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-background-400 hover:text-primary-300 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-800 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} 17c.com GitHub 资源汇总 — 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-sm text-background-500 hover:text-primary-300 transition-colors">
              隐私政策
            </Link>
            <Link to="/about" className="text-sm text-background-500 hover:text-primary-300 transition-colors">
              服务条款
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}